import { baseApi } from "../api/baseApi.ts";
import type { DomainReportResponse } from "../api/types.ts";

export const reportsApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        // Get comprehensive domain exposure report
        getDomainReport: builder.query<DomainReportResponse, string>({
            query: (searchTerm) => ({
                url: '/reports/',
                method: 'GET',
                // FIX: Changed the parameter key from 'domain' to 'query'
                params: { query: searchTerm },
            }),
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetDomainReportQuery,
    useLazyGetDomainReportQuery,
} = reportsApi;